template.main_nav = function () {

	// New sub menu
	const sectionEls = $("main-header__bottom-wrap .main-nav-sub__list");
	const navLinkEls = $(".main-nav .menu-item");
	const popoverEl = $(".main-nav-sub");
	const contentEl = $(".main-header__bottom-wrap .content");
	const arrowEl = $(".main-header__bottom-wrap .arrow");
	const backgroundEl = $(".main-header__bottom-wrap .background");

	var dimensions = {};
	function subMenuSizes() {
		navLinkEls.each(function () {

			// Get the section associated with the nav link
			var $id = $(this).attr('id');
			let section = $('[data-parent="' + $id + '"]');
			let popoverLeft = popoverEl[0].getBoundingClientRect().x;

			if (section.length) {
				$(this).addClass('has-child');
				// Get the bounding rectangle of the nav link
				let rect = $(this).children('a')[0].getBoundingClientRect();
				dimensions[$id] = {
					width: section.outerWidth(),
					height: section.outerHeight(),
					x: section.position().left,
					// Set the arrow X coordinate
					arrowX: rect.left + (rect.width / 2) - popoverLeft
				};
			}
		
		});
	}

	subMenuSizes();

	$(window).on('load resize', function () {
		subMenuSizes();
	});

	// Set the initial arrow position
	arrowEl.css("transform", 'translateX(' + dimensions[Object.keys(dimensions)[0]].arrowX + 'px)rotate(45deg)');

	//Set the initial background size
	backgroundEl.css({
		"height": dimensions[Object.keys(dimensions)[0]].height + "px",
		"width"	: dimensions[Object.keys(dimensions)[0]].width + "px"
	});

	// Function to show a menu section
	function showSection(section) {

		// Add the "open" class to the popover
		popoverEl.addClass("open");
	
		// Remove the "active" class from all the section elements
		sectionEls.removeClass("active");
	
		// Add the "active" class to the section element with the given name
		$('[data-parent="' + section + '"]').addClass("active");
	
		// Position the arrow
		arrowEl.css("transform", 'translateX(' + dimensions[section].arrowX + 'px)rotate(45deg)');
	
		// Resize and position the background
		backgroundEl.css(
			"transform", "translateX(" + dimensions[section].x + "px) scaleX(" + (dimensions[section].width / dimensions[Object.keys(dimensions)[0]].width) + ") scaleY(" + (dimensions[section].height / dimensions[Object.keys(dimensions)[0]].height) + " )"
		);
	
		// Resize and position the content
		contentEl.css("width", dimensions[section].width + "px");
		contentEl.css("height", dimensions[section].height + "px");
	
		contentEl.css("transform", 'translateX(' + dimensions[section].x + 'px)');
	
		//
	}
	var timeoutId = '';
	$('.main-nav .menu-item').on({
		'mouseenter': function () {
			var $id = $(this).attr('id');
			var $thisSubMenu = $('[data-parent="' + $id + '"]');

			// remove search classes
			$('.main-search, .main-search-mobile').removeClass('active');
			$('.main-search-panel').removeClass('active');
			$('.main-search__text, .main-search-mobile__text').text('Search');
			$('.main-search-panel .main-search-form__input').blur();

			if ($thisSubMenu.length) {
				clearTimeout(timeoutId);
				if ($('.main-header__menu-btn').css('display') == 'none') {
					// remove menu classes
					removeMenuClasses();
					//$('.main-nav-sub').addClass('active');
					$thisSubMenu.addClass('active');

					showSection($id);
				}
			}
		},
		'mouseleave': function () {
			if ($('.main-header__menu-btn').css('display') == 'none') {
				// remove menu classes
				timeoutId = setTimeout(function() {
					removeMenuClasses();
				}, 300);
			}
		},
		'click': function (e) {
			if ($('.main-header__menu-btn').css('display') != 'none' && !$(this).children('a').is(e.target)) {
				popoverEl.fadeIn(200);
				var $id = $(this).attr('id');
				var $thisSubMenu = $('[data-parent="' + $id + '"]');
				$thisSubMenu.addClass('active');
			}
		}
	});

	$('.main-nav-sub .content').on({
		'mouseenter': function () {
			clearTimeout(timeoutId);
		},
		'mouseleave': function () {
			if ($('.main-header__menu-btn').css('display') == 'none') {
				// remove menu classes
				timeoutId = setTimeout(function() {
					removeMenuClasses();
				}, 300);
			}
		},
	});

	// Remove menu active if search is hovered
	$('.main-search').on({
		'mouseenter': function() {
			removeMenuClasses();
			popoverEl.removeClass("open");
		}
	});

	// $('.').on({
	// 	'mouseleave': function() {
	// 		if ($('.main-header__menu-btn').css('display') == 'none') {
	// 			// remove menu classes
	// 			removeMenuClasses();
	// 		}
	// 	}
	// });

	$('.sub-menu-close').on({
		'click': function() {
			if ($('.main-header__menu-btn').css('display') != 'none') {
				// remove menu classes
				popoverEl.fadeOut(200);
				$('[data-parent]').removeClass('active');
			}
		}
	});

	// Mobile
	$('.main-header__menu-btn').on({
		'click': function(e) {
			e.preventDefault();

			if(!$('.main-header__menu-btn').hasClass('active')) {
				$('.main-header__menu-btn').addClass('active');
				$('.main-header__menu-btn-text').text('Close');
				$('.main-nav').addClass('mobile-active');
				$('body').addClass('no-scroll');
			} else {
				removeMobileMenuClasses();
				$('body').removeClass('no-scroll');
			}
		}
	});
	$('.main-header__top-options-mobile .profile-menu-trigger').on({
		'click': function(e) {
			e.preventDefault();

			if(!$(this).hasClass('active')) {
				$(this).addClass('active');
				$(this).siblings('.profile-menu').addClass('active');
			} else {
				$(this).removeClass('active');
				$(this).siblings('.profile-menu').removeClass('active');
			}
		}
	});


	$('body').on({
		'click': function(e) {
			if(
				(!$('.main-nav, .main-nav-sub').is(e.target) && !$('.main-nav, .main-nav-sub').has(e.target).length) &&
				(!$('.main-header__menu-btn').is(e.target) && !$('.main-header__menu-btn').has(e.target).length)
			) {
				removeMobileMenuClasses();
			}
			if (!$('.main-header__top-options-mobile .profile-menu-container *').is(e.target)) {
				$('.main-header__top-options-mobile .profile-menu-trigger').removeClass('active');
				$('.main-header__top-options-mobile .profile-menu-trigger').siblings('.profile-menu').removeClass('active');
			}
		}
	});

	function removeMenuClasses() {
		if ($('.main-header__menu-btn').css('display') == 'none') {
			popoverEl.removeClass("open");
		}
		$('.main-nav .menu-item').removeClass('active');
		$('.main-nav-sub').removeClass('active');
		$('[data-parent]').removeClass('active');
	}

	function removeMobileMenuClasses() {
		if ($('.main-header__menu-btn').css('display') != 'none') {
			popoverEl.fadeOut(200);
		}
		$('.main-header__menu-btn, .main-nav-sub__list').removeClass('active');
		$('.main-header__menu-btn-text').text('Menu');
		$('.main-nav').removeClass('mobile-active');
	}

};

var nav = document.querySelector('.main-header__bottom');

if(document.body.contains(nav)) {
	var topOfNav = nav.offsetTop;
}
var search = document.querySelector('.main-search');
var contact = document.querySelector('.menu-item:last-child');

if(document.body.contains(nav && search && contact)) {

	function fixNav() {
		if(window.scrollY >= topOfNav) {
			//contact.id = 'showContact';
			search.style.display = 'none';
			document.body.style.paddingTop = nav.offsetHeight + 'px';
			document.body.classList.add('fixed-nav');
		} else {
			//contact.id = '';
			document.body.classList.remove('fixed-nav');
			search.style.display = 'flex';
			document.body.style.paddingTop = 0;
			//contact.removeAttribute('id');
		}
	}

	window.addEventListener('scroll', fixNav);

}
